/**
 * Robust active-path detection that works for both absolute paths
 * (e.g. "/user/modules/abc") and relative segment paths used by the admin
 * menu (e.g. "flow", "helios", "core"). Avoids false positives like
 * "/user/modules" matching "/user/modules-x".
 */
export const isPathActive = (pathname: string, path: string): boolean => {
  const normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (path.startsWith('/')) {
    return normalizedPathname === path || normalizedPathname.startsWith(`${path}/`);
  }
  const segments = normalizedPathname.split('/').filter(Boolean);
  return segments.includes(path);
};
